<template>
  <div class="update-data-container">
    <div class="update-data-title">Alterar dados</div>
    <div class="user-info-list">
      <Input
        class="user-info-item"
        v-for="(infoKey, i) in Object.keys(userInfo)"
        disabled
        :key="i"
        :label="infoKey"
        :value="userInfo[infoKey]"/>
    </div>
    <div class="installment-title" v-apply-theme>
      Escolha um valor de entrada
    </div>
    <DownPaymentList
      id="down-payment-list"
      v-if="downPaymentOptions"
      :loadingValues="downPaymentValueSkeleton"
      :indexSelected="downPaymentIndexShow"
      @downPaymentChange="onDownpaymentChange"
      :downPaymentOptions="downPaymentOptions"
    />
    <div class="installment-title" v-apply-theme>
      Quantidade de parcelas
    </div>
    <InstallmentSelect
      id="installment-select"
      ref="installment-select"
      :indexSelected="installmentIndexShow"
      v-if="downPaymentShow"
      @installmentSelect="onInstallmentSelect"
      :installments="downPaymentShow.options"
    />
    <CheckoutSummary
      id="update-data-summary"
      v-if="downPaymentShow"
      :loading="summarySkeleton"
      :downPaymentValue="downPaymentShow.downPaymentValue"
      :downPaymentPercentage="downPaymentShow.downPaymentPercentage"
      :totalAmount="installmentShow && installmentShow.totalAmount"
      :interestRatePM="installmentShow && installmentShow.interestRatePM"
      :cetPA="installmentShow && installmentShow.cetPA"
      :oneLineFooter="false"
    />
    <div class="update-summary-footer">
      <Button v-if="!isMobile()" class="cancel-btn" @click="cancel">Cancelar</Button>
      <Button @click="update" class="apply-btn" :disabled="summarySkeleton">
        Aplicar alterações
      </Button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import debug from 'debug';
import Button from '@/components/ui/AppButton.vue';
import Input from '@/components/ui/AppInput.vue';
import DownPaymentList from '@/components/common/DownPaymentList.vue';
import InstallmentSelect from '@/components/common/InstallmentSelect.vue';
import globals from '@/globals';
import UtilMixin from '@/mixins/util';
import { ApplyTheme } from '@/directives/applyTheme';
import CheckoutSummary from './CheckoutSummary.vue';

const skeletonTimeout = globals().skeleton.checkout.timeout;

const log = debug('vue:checkout:summary');

export default {
  name: 'update-data-summary',
  mixins: [UtilMixin],
  directives: {
    ApplyTheme,
  },
  methods: {
    onInstallmentSelect(index) {
      log('onInstallmentSelect');
      this.installmentIndexShow = index;
      this.summarySkeletonToggle();
    },
    onDownpaymentChange(index) {
      log('onDownpaymentChange');
      this.downPaymentIndexShow = index;
      this.summarySkeletonToggle();
    },
    summarySkeletonToggle() {
      this.summarySkeleton = true;
      setTimeout(() => {
        this.summarySkeleton = false;
      }, skeletonTimeout);
    },
    update() {
      log('update');
      this.$emit('update', {
        downPaymentIndex: this.downPaymentIndexShow,
        installmentIndex: this.installmentIndexShow,
      });
    },
    cancel() {
      log('cancel');
      this.$emit('cancel');
    },
  },
  data: () => ({
    downPaymentIndexShow: null,
    installmentIndexShow: null,
    summarySkeleton: false,
    downPaymentValueSkeleton: false,
  }),
  mounted() {
    this.downPaymentIndexShow = this.downPaymentIndexSelected;
    this.installmentIndexShow = this.installmentIndexSelected;
  },
  computed: {
    ...mapState('checkout', [
      'downPaymentIndexSelected',
      'installmentIndexSelected',
      'downPaymentOptions',
    ]),
    ...mapGetters('checkout', [
      'downPaymentSelected',
    ]),
    downPaymentShow() {
      if (!this.downPaymentOptions) return null;
      return this.downPaymentOptions[this.downPaymentIndexShow];
    },
    installmentShow() {
      if (!this.downPaymentShow) return null;
      if (!this.downPaymentShow.options) return null;
      return this.downPaymentShow.options[this.installmentIndexShow];
    },
  },
  components: {
    Button,
    Input,
    DownPaymentList,
    InstallmentSelect,
    CheckoutSummary,
  },
  props: {
    userInfo: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>

.update-data-container {
  padding: 20px 24px;
  @media (max-width: $md) {
    margin-bottom: 98px;
    margin-top: 64px;
  }
}

.update-data-title {
  @extend .h3;
  @extend .gray-600;
  margin-bottom: 20px;
  @media (max-width: $md) {
    position: fixed;
    background-color: var(--white);
    left: 0;
    right: 0;
    z-index: 2;
    padding: 20px;
    top: 0;
    margin: 0;
  }
}

.user-info-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: $md) {
    flex-direction: column;
  }
}

.user-info-item {
  flex: 0 48%;
  margin-bottom: 20px;
}

#installment-select {
  margin-bottom: 20px;
}

#down-payment-list {
  margin-bottom: 20px;
}

.installment-title, .down-payment-list-title {
  @extend .body-bold;
  margin-bottom: 8px;
  color: var(--gray-600);
  &--vivo {
    font-weight: normal;
  }
}

.update-summary-footer {
  margin-top: 20px;
  text-align: right;
  @media (max-width: $md) {
    width: 100%;
    position: fixed;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    padding: 20px;
    background-color: var(--white);
    box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.15);
  }
}

.cancel-btn {
  margin-right: 16px;
}

.apply-btn {
  @extend .primary;
  @media (max-width: $md) {
    width: 100%;
    height: 48px;
  }
}
</style>
